module.exports = __webpack_public_path__ + "img/building.42af7079.png";